<template>
    <button class="joy-link link-button" :class="{'link-button__no-text-decoration': noTextDecoration}" :data-testid="dataTestid">
        <template v-if="icon">
            <VJoyIcon :name="icon" />
            &nbsp;
        </template>
        <slot />
    </button>
</template>

<script setup lang="ts">
    /**
     * LinkButton rely on 'joy-link' CSS class from design system.
     * Purpose is to have a simple button looking like a regular link.
     */
    import {VJoyIcon} from '@maltjoy/core-vue';
    import type {TJoyIconsNames} from '@maltjoy/core-vue';

    defineProps<{
        dataTestid: string;
        icon?: TJoyIconsNames;
        noTextDecoration?: boolean;
    }>();
</script>

<style scoped lang="scss">
    .link-button {
        font-weight: var(--joy-font-weight-normal);
        padding: 2px 5px;

        &__no-text-decoration:hover {
            text-decoration: none;

            :deep(*) {
                text-decoration: none;
            }
        }
    }
</style>
